/* eslint-disable @next/next/no-img-element */

// components
import { Container } from 'components/Grid';
import { SectionTitle } from '@/components/SectionTitle';
import { VideoPlayer } from '@/containers-m/VideoPlayer';

// styles
import {
  SectionWrapper,
  TitleWrapper,
  MediaWrapper,
} from './VideoContainer.styles';

export function VideoContainer() {
  const video_settings = {
    preview: '/videos/shipperguide/bg_sg-demo.webm',
    youtube: 'https://www.youtube.com/watch?v=_BjZ4WAsN74?rel=0',
    thumb: '/images/shipperguide/image-cta/shipperguide-dashboard@2x.png',
  };

  return (
    <SectionWrapper>
      <Container>
        <TitleWrapper>
          <SectionTitle
            title={
              <>
                Easy procurement and
                <br /> execution, in one place.
              </>
            }
            subtitle={`Say goodbye to complex logistics systems`}
            variant="center"
          />
        </TitleWrapper>

        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>
      </Container>
    </SectionWrapper>
  );
}
